/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_PayrollInputs */

const es_tools_legajox_payroll = /** @type {(inputs: Tools_Legajox_PayrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultando recibos de sueldo en Legajox...`)
};

const en_tools_legajox_payroll = /** @type {(inputs: Tools_Legajox_PayrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Querying Legajox payroll...`)
};

/**
* | output |
* | --- |
* | "Querying Legajox payroll..." |
*
* @param {Tools_Legajox_PayrollInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_payroll = /** @type {((inputs?: Tools_Legajox_PayrollInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_PayrollInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_payroll(inputs)
	return en_tools_legajox_payroll(inputs)
});
export { tools_legajox_payroll as "tools.legajox.payroll" }